import React, { useEffect, useMemo } from "react";
import { Modal } from 'react-bootstrap';
import CurrencyInput from "react-currency-input-field";
import { useHistory } from "react-router";
import { searchEsProduct } from "../../../api";
import distributorApi from "../../../api/distributor";
import { DistributorInventoryModel, ProductModel, ProductViewModel } from "../../../models";
import { formatPrice, useAsync, useQuery } from "../../../utils";
import useViewModel from "../../../viewModel/base";
import distributorVM from "../../../viewModel/distributor";
import { Header } from "../../shared";
import { useRecoilValue } from "recoil";
import { accountDataState } from "../../../recoil/account";

const DistributorOrderEdit = () => {
    const query = useQuery();
    const history = useHistory();
    const distributorInventoryId: number = parseInt(query.get("distributorInventoryId") || '')
    const distributorId: number = parseInt(query.get("distributorId") || '')
    const orderId: number = parseInt(query.get("orderId") || '')
    const productId: string = query.get("productId") || ''
    const accountInfo = useRecoilValue(accountDataState)
    const adminId = useMemo(() => {
        if (accountInfo.loginSession.userLocalType === 'ADMIN')
            return accountInfo.doctor.mId
    }, [accountInfo])

    const searchProductAsync = useAsync(searchEsProduct)
    const { execute: getDistributorInventories, value: distributorInventories, status: getDistributorInventoriesStatus } = useAsync(distributorApi.getDistributorInventories)
    const { execute: editOrder, status: editOrderStatus } = useAsync(distributorApi.editOrder)
    const { execute: getPharmacyOrderDetail, value: orderDetail } = useAsync(distributorApi.getPharmacyOrderDetail)

    const viewModel = useViewModel({
        showSuccess: false,
        selectedAmount: '1',
        selectedPkg: {} as DistributorInventoryModel
    })

    useEffect(() => {
        getPharmacyOrderDetail(orderId, { include: [{ relation: "mItems" }], })
            .then(res => {
                viewModel.updateData({
                    selectedAmount: res.mItems && res.mItems[0]?.mTotalItems.toString()
                })
            })
    }, [orderId])

    useEffect(() => {
        getDistributorInventories({
            where: {
                and: [
                    { mProductId: productId },
                    { mDistributorId: distributorId }
                ]
            }
        }, adminId)
    }, [productId, distributorId])

    useEffect(() => {
        if (!distributorInventories || !distributorInventoryId) return

        const selectedPkg = distributorInventories.find(item => item.mId === distributorInventoryId)

        if (selectedPkg) {
            viewModel.updateData({ selectedPkg })
        }
    }, [distributorInventoryId, distributorInventories])

    useEffect(() => {
        if (!productId) return
        searchProductAsync.execute(getQuery(productId));
    }, [productId])

    const getQuery = (productId: string) => {
        return {
            query: {
                match: {
                    _id: productId,
                },
            },
        };
    };

    const product: ProductModel = useMemo(() => {
        const _product = searchProductAsync.value?.data[0];

        return {
            ..._product,
        };
    }, [searchProductAsync.value])

    const productVM = new ProductViewModel(product);

    const handleEditOrder = () => {
        const payload = {
            ...orderDetail,
            mItems: [{
                ...(orderDetail.mItems && orderDetail.mItems[0] || {}),
                mInventoryId: viewModel.data.selectedPkg.mId,
                mProductId: product._id,
                mProductName: product.name,
                mProductImage: product.imageUrls && product.imageUrls[0],
                mPkgPrice: viewModel.data.selectedPkg?.mPrice,
                mDiscountPrice: viewModel.data.selectedPkg?.mDiscountPrice,
                mDiscountStatus: viewModel.data.selectedPkg?.mDiscountStatus,
                mPkgName: viewModel.data.selectedPkg?.mPkgName,
                mTotalItems: parseInt(viewModel.data.selectedAmount),
                mDiscountHtml: orderDetail?.mItems && orderDetail?.mItems[0] && orderDetail?.mItems[0].mDiscountHtml || undefined
            }],
        }

        editOrder(orderId, payload).then(res => {
            viewModel.updateData({ showSuccess: true })
        })
    }

    return <>
        <Header title="Sửa đơn" />
        <div id="main">
            <div className="container">
                <div className="product-summary d-flex">
                    <div className="product-thumb">
                        <img src={product.imageUrls && product.imageUrls[0]} className="img-fluid" width={75} />
                    </div>
                    <div>
                        <p><strong>{viewModel.data.selectedPkg?.mProductName}</strong></p>
                        {/* <strong>{formatPrice(viewModel.data.selectedPkg?.mPrice)} đ/ {viewModel.data.selectedPkg?.mPkgName}</strong> */}
                        <strong className="txt-orange">
                            {formatPrice(distributorVM.getDitributorInvPrice(viewModel.data.selectedPkg?.mPrice, viewModel.data.selectedPkg?.mDiscountPrice, viewModel.data.selectedPkg?.mDiscountStatus))} đ/ {viewModel.data.selectedPkg?.mPkgName}
                        </strong>
                        {
                            !!distributorVM.getDitributorInvBeforeDiscountPrice(viewModel.data.selectedPkg?.mPrice, viewModel.data.selectedPkg?.mDiscountPrice, viewModel.data.selectedPkg?.mDiscountStatus) &&
                            <div className='d-flex w-100 align-items-center'>
                                <div style={{ color: '#707070', textDecoration: 'line-through', whiteSpace: 'nowrap', fontSize: 13 }}>
                                    {formatPrice(distributorVM.getDitributorInvBeforeDiscountPrice(viewModel.data.selectedPkg?.mPrice, viewModel.data.selectedPkg?.mDiscountPrice, viewModel.data.selectedPkg?.mDiscountStatus))} đ/ {viewModel.data.selectedPkg?.mPkgName}
                                </div>
                                <div className='ml-2' style={{ padding: 5, backgroundColor: '#fdeee2', fontSize: 11, borderRadius: 5 }}>
                                    Giảm chiết khấu
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div className="product-actions d-flex align-items-center mb-3">
                    <div className="quality">
                        <div className="group-input d-flex">
                            <button
                                onClick={() => {
                                    if (parseInt(viewModel.data.selectedAmount) === 1) return
                                    viewModel.updateData({ selectedAmount: (parseInt(viewModel.data.selectedAmount) - 1).toString() })
                                }}
                                className={`${parseInt(viewModel.data.selectedAmount) === 1 && "disable"}`}
                            ><span className="fa fa-minus">-</span></button>
                            <CurrencyInput
                                groupSeparator="."
                                decimalSeparator=","
                                onValueChange={(value) => {
                                    viewModel.updateData({ selectedAmount: value || '' })
                                }}
                                className="input"
                                style={{ minWidth: 75 }}
                                value={viewModel.data.selectedAmount}
                                onBlur={(e) => {
                                    if (!e.target.value || e.target.value === '0') {
                                        viewModel.updateData({ selectedAmount: '1' })
                                    }
                                }}
                            />
                            <button
                                onClick={() => {
                                    viewModel.updateData({ selectedAmount: (parseInt(viewModel.data.selectedAmount) + 1).toString() })
                                }}
                            ><span className="fa fa-plus">+</span></button>
                        </div>
                    </div>
                    <div className="ml-3">
                        <select
                            className="form-control smaller"
                            style={{ height: 32 }}
                            value={viewModel.data.selectedPkg?.mId}
                            onChange={(e) => {
                                const selectedPkg = distributorInventories.find(item => item.mId === parseInt(e.target.value))
                                viewModel.updateData({ selectedPkg })
                            }}
                        >
                            {
                                distributorInventories?.map(item => {
                                    return <option
                                        key={item.mId}
                                        selected={item.mId === viewModel.data.selectedPkg.mId}
                                        value={item.mId}
                                    >
                                        {item.mPkgName}
                                    </option>
                                })
                            }
                        </select>
                    </div>
                    <div className="ml-auto d-flex txt-orange" style={{ whiteSpace: 'nowrap' }}>
                        {formatPrice(+viewModel.data.selectedAmount * distributorVM.getDitributorInvPrice(viewModel.data.selectedPkg?.mPrice, viewModel.data.selectedPkg?.mDiscountPrice, viewModel.data.selectedPkg?.mDiscountStatus))} đ
                    </div>
                </div>
                <div className="product-detail-content pb-4">
                    <p>Nhà phân phối: {viewModel.data.selectedPkg?.mDistributor?.mName}</p>
                    <div className="product-detail">
                        <div>
                            {
                                productVM.getViewDetailInfo().map((info, index) => {
                                    return <>
                                        <b>{index + 1}. {info.title}: </b>
                                        <p>
                                            <div dangerouslySetInnerHTML={{ __html: info.value }} />
                                        </p>
                                    </>
                                })
                            }
                        </div>
                    </div>
                </div>
                <div style={{ height: 72 }}>
                    <div className="fixed-button d-flex justify-content-between">
                        <a className="btn btn-white" onClick={() => history.push(`/distributor-order-info?orderId=${orderId}`)}>HỦY</a>
                        <a className="btn" onClick={handleEditOrder}>GỬI LẠI ĐƠN</a>
                    </div>
                </div>

            </div>
        </div>

        <Modal show={viewModel.data.showSuccess} onHide={() => viewModel.updateData({ showSuccess: false })}>
            <div className="modal-header">
                <img src="./images/check.svg" alt="Thành công" className="img-fluid" width={48} />
            </div>
            <div className="modal-body">
                <h3>Đặt hàng thành công!</h3>
            </div>
            <div className="modal-footer d-block px-4">
                <a onClick={() => { history.push('/distributor-dashboard?tab=inventories') }} className="btn btn-block mw-100">QUAY LẠI CHỌN SẢN PHẨM</a>
                <br />
                <a onClick={() => { history.push(`/distributor-order-info?orderId=${orderId}`) }} className="btn btn-block btn-border mw-100 line-height-18">XEM ĐƠN HÀNG</a>
            </div>
        </Modal>

    </>
}

export default DistributorOrderEdit